/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitImageExtensionEnum } from './PressKitImageExtensionEnum';
import {
    PressKitImageExtensionEnumFromJSON,
    PressKitImageExtensionEnumFromJSONTyped,
    PressKitImageExtensionEnumToJSON,
} from './PressKitImageExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * 
 * @export
 * @interface PostPressKitBodyImagesInner
 */
export interface PostPressKitBodyImagesInner {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    objectId: string;
    /**
     * 既存画像のUUID。空文字だと新規作成される。
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    id?: string;
    /**
     * S3へのURI、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    resourceUri: string;
    /**
     * 
     * @type {PressKitImageExtensionEnum}
     * @memberof PostPressKitBodyImagesInner
     */
    extension: PressKitImageExtensionEnum;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像は不要。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyImagesInner
     */
    width?: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像は不要。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyImagesInner
     */
    height?: number;
    /**
     * ファイルのサイズ（単位はbytes）。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyImagesInner
     */
    fileSize: number;
    /**
     * アップロードされたファイルの名前。resource_uri変更時だけ変更可能。
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    filename: string;
    /**
     * キャプションとして使われるファイルの名前。設定されなければfilenameが使われる。
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    title?: string;
    /**
     * 企業が登録したファイルの説明文
     * @type {string}
     * @memberof PostPressKitBodyImagesInner
     */
    description?: string;
    /**
     * 
     * @type {Array<PressKitTag>}
     * @memberof PostPressKitBodyImagesInner
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PostPressKitBodyImagesInner interface.
 */
export function instanceOfPostPressKitBodyImagesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PostPressKitBodyImagesInnerFromJSON(json: any): PostPressKitBodyImagesInner {
    return PostPressKitBodyImagesInnerFromJSONTyped(json, false);
}

export function PostPressKitBodyImagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyImagesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'resourceUri': json['resource_uri'],
        'extension': PressKitImageExtensionEnumFromJSON(json['extension']),
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'fileSize': json['file_size'],
        'filename': json['filename'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PostPressKitBodyImagesInnerToJSON(value?: PostPressKitBodyImagesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'id': value.id,
        'resource_uri': value.resourceUri,
        'extension': PressKitImageExtensionEnumToJSON(value.extension),
        'width': value.width,
        'height': value.height,
        'file_size': value.fileSize,
        'filename': value.filename,
        'title': value.title,
        'description': value.description,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

